var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72351 14.381L9.3632 8.96686C9.56507 8.77347 9.72522 8.54376 9.83448 8.29088C9.94375 8.038 10 7.76692 10 7.49314C10 7.21937 9.94375 6.94828 9.83448 6.6954C9.72522 6.44252 9.56507 6.21281 9.3632 6.01942L3.72351 0.605316C2.35169 -0.690724 -4.00476e-08 0.229046 -3.65338e-07 2.08949L-2.25495e-06 12.8968C-2.58389e-06 14.7781 2.35169 15.6979 3.72351 14.381Z",
    fill: "#1E415A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.3db18f56da0a99397067850f7f561950.svg";
export { ForwardRef as ReactComponent };